import { useQuery } from "@tanstack/react-query";

import { IWard } from "../../../@types/admin/AdminWard";
import { IPaginatedResponse } from "../../../@types/PaginatedResponse";
import { wardsService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";

export function useWards() {
  const { data, isLoading, isError, isFetching } = useQuery<
    IPaginatedResponse<IWard[]>
  >({
    queryKey: ["admin-wards"],
    queryFn: async () => ensureOk(await wardsService.getWards()),
    // No manual Refresh button on migrated admin pages (EN-5129 UI feedback),
    // and the global QueryClient disables refetch-on-mount with a 3-minute
    // staleTime — so re-opening the page must re-read the list.
    refetchOnMount: "always",
  });

  return { wards: data?.result ?? [], isLoading, isError, isFetching };
}

export function useWardDetails(wardId: number | undefined) {
  const { data, isLoading, isError } = useQuery<IWard>({
    queryKey: ["admin-ward-details", wardId],
    queryFn: async () => ensureOk(await wardsService.getWardById(wardId!)),
    enabled: Boolean(wardId),
    refetchOnMount: "always",
  });

  return { ward: data, isLoading, isError };
}
